import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTeams } from '../../contexts/TeamsContext';
import { TeamFeatures } from 'api-client/models';

interface FeatureProtectedRouteProps {
  featureKey: keyof TeamFeatures;
  children: React.ReactNode;
  fallbackComponent?: React.ReactNode;
  fallbackPath?: string;
}

export const FeatureProtectedRoute: React.FC<FeatureProtectedRouteProps> = ({
  featureKey,
  children,
  fallbackComponent,
  fallbackPath = '/dashboard',
}) => {
  const { currentTeam } = useTeams();
  
  const hasFeatureAccess = currentTeam?.features?.[featureKey] === true;
  
  if (!hasFeatureAccess) {
    if (fallbackComponent) {
      return <>{fallbackComponent}</>;
    }
    return <Navigate to={fallbackPath} replace />;
  }
  
  return <>{children}</>;
};
